<!-- eslint-disable vue/no-v-html -->
<template>
  <div :class="['toast-message', { 'toast-message--hide': !toastList.length }]">
    <div
      v-for="toast in toastList"
      :key="toast.message"
      :class="`toast-message__content toast-message__content--${getType(
        toast.type
      )}`"
    >
      <i
        :class="`toast-message__icon icon icon--toast-${getType(toast.type)}`"
      ></i>
      <span class="toast-message__message" v-html="toast.message"></span>
      <button class="toast-message__close" @click="removeToast(toast)">
        <i class="icon icon--close"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToastMessage',
  data() {
    return {
      flashes: [],
    };
  },
  computed: {
    toastList() {
      return this.flashes;
    },
  },
  mounted() {
    window.addToastMessages = () => {
      this.flashes = window.flashMessages;
      document.body.scrollTo(0, 0);
    };

    window.addToastMessages();
  },
  methods: {
    removeToast(toast) {
      let index = this.flashes.indexOf(toast);
      this.flashes.splice(index, 1);
    },
    getType(type) {
      const match = {
        'alert-success': 'success',
        'alert-error': 'error',
        'alert-info': 'info',
      };

      return match[type];
    },
  },
};
</script>
